
import CategoriesSectionContainer from './categories/CategoriesSectionContainer';
import MobileShopByCategoryToggle from './categories/MobileShopByCategoryToggle';
import { useIsMobile } from '@/hooks/use-mobile';

const CategoriesSection = () => {
  // Was `<div className="hidden md:block">` — CSS-only hiding, so this instance stayed
  // mounted (and its category-product-counts RPC kept firing) on mobile regardless of
  // visibility. Gating the mount itself, the same way MobileShopByCategoryToggle already
  // gates its own copy on `isExpanded`, means the query genuinely doesn't fire until the
  // component actually needs to render.
  const isMobile = useIsMobile();

  return (
    <>
      {/* Mobile collapsible version */}
      <MobileShopByCategoryToggle />

      {/* Desktop version — only mounted on desktop viewports */}
      {!isMobile && <CategoriesSectionContainer />}
    </>
  );
};

export default CategoriesSection;
